var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTimes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5892 5.58909C15.9147 5.26366 15.9147 4.73602 15.5892 4.41058C15.2638 4.08514 14.7361 4.08514 14.4107 4.41058L9.99996 8.82133L5.58922 4.41058C5.26378 4.08514 4.73614 4.08514 4.4107 4.41058C4.08527 4.73602 4.08527 5.26366 4.4107 5.58909L8.82145 9.99984L4.4107 14.4106C4.08527 14.736 4.08527 15.2637 4.4107 15.5891C4.73614 15.9145 5.26378 15.9145 5.58922 15.5891L9.99996 11.1783L14.4107 15.5891C14.7361 15.9145 15.2638 15.9145 15.5892 15.5891C15.9147 15.2637 15.9147 14.736 15.5892 14.4106L11.1785 9.99984L15.5892 5.58909Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/times.65fc5946.svg";
export { ForwardRef as ReactComponent };